// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.prof-about-modal__main-wrapper[data-v-d53140f2] {\n  display: block;\n  width: 100%;\n  padding: 35px;\n  padding-top: 10px;\n}\n.prof-about-modal__textarea[data-v-d53140f2] {\n  height: 100px;\n}\n", ""]);
// Exports
module.exports = exports;
